import React from 'react';

import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

import Switch from '~/components/Switch/Switch';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { SMALL_MARGIN_PX } from '~/theme';

const PriceSwitcherSticky = ({ isAnnual, toggleSwitch }) => {
  const { t } = useTenantTranslation();

  return (
    <CardSwitcher>
      <SwitchCaption
        isActive={!isAnnual}
        data-testid="monthlyOption"
        onClick={() => toggleSwitch(false)}
      >
        {t('common.monthly')}
      </SwitchCaption>
      <Switch
        size="small"
        value={isAnnual}
        onChange={() => toggleSwitch(null)}
        data-testid="planDurationSwitcher"
      />
      <SwitchCaption isActive={isAnnual} onClick={() => toggleSwitch(true)}>
        {t('common.annual')}
      </SwitchCaption>
    </CardSwitcher>
  );
};

export default PriceSwitcherSticky;

const CardSwitcher = styled('div')`
  display: flex;
  align-items: center;

  & label {
    margin: 0 ${SMALL_MARGIN_PX};
  }
`;
const SwitchCaption = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  font-weight: 700;
  font-size: 14px;
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.common.gray : alpha(theme.palette.common.white, 0.33)};
  text-transform: uppercase;
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: initial;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    font-size: 18px;
  }
`;
